import { useQuery } from '@tanstack/react-query';

import VendorsService from '~/services/VendorsService';

import { VendorMonthlySummary } from '~/types/services/vendor';

export type VendorMonthlySummaryType = 'all' | 'lpc';

export const vendorMonthlySummaryQueryKeys = {
  all: ['vendor-monthly-summary'] as const,
  detail: (vendorId: string, month: string, type: VendorMonthlySummaryType) =>
    [...vendorMonthlySummaryQueryKeys.all, vendorId, month, type] as const,
};

type Params = {
  vendorId: string | null;
  month: string;
  type?: VendorMonthlySummaryType;
  enabled?: boolean;
};

export function useGetMonthlyVendorSummary({ vendorId, month, type = 'all', enabled = true }: Params) {
  return useQuery({
    queryKey: vendorMonthlySummaryQueryKeys.detail(vendorId ?? '', month, type),
    queryFn: async ({ signal }): Promise<VendorMonthlySummary> => {
      if (!vendorId) throw new Error('vendorId is required');
      const response = await VendorsService.getMonthlySummary(vendorId, { month, type }, { signal });
      return response.data;
    },
    enabled: enabled && !!vendorId && !!month,
    staleTime: 5 * 60 * 1000,
  });
}
